import { ENRG_QSTRING } from '@vfit/consumer/data-access';

const getPostData = () => {
  const queryString = new URLSearchParams(window?.location?.search);
  const m = queryString?.get(ENRG_QSTRING.MSISDN)?.replace(/ /g, '+');
  const a = queryString?.get(ENRG_QSTRING.ACCOUNT)?.replace(/ /g, '+');
  const c = queryString?.get(ENRG_QSTRING.CHECKSUM)?.replace(/ /g, '+');
  return {
    msisdn: m,
    account: a,
    checksum: c,
  };
};

const getFwvPostEP = () => {
  const isDevLocal = process.env['NODE_ENV'] === 'development';
  if (isDevLocal) return 'http://localhost:6767/api';
  return process?.env?.['NEXT_PUBLIC_FW_POST_FORM'] || '';
};

export { getPostData, getFwvPostEP };
